import React from "react";

import { Button } from "@/components/ui/button";
import { Link } from "@/lib/i18n";

import LogoIcon from "./LogoIcon";
type Props = {};

export default function footer({}: Props) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 py-2 px-8 md:mt-0 mt-10">
      <div className="flex flex-col lg:flex-row items-center gap-2">
        <div className="flex  items-center gap-2">
          <LogoIcon className="h-4 w-4" />
          <h5 className="text-muted-foreground font-medium text-xs ">
            ARYA Crypto
          </h5>
        </div>
        <p className="text-muted-foreground text-xs">
          © 2024 Greenbull Technology DMCC.
        </p>
      </div>
      <div className="flex items-center justify-center lg:justify-end">
        <Button
          variant={"link"}
          className="text-muted-foreground font-medium text-xs"
        >
          <Link href="mailto:contact@arya.com">Support</Link>
        </Button>
        <Button
          variant={"link"}
          className="text-muted-foreground font-medium text-xs"
        >
          <Link href="/privacy">Privacy</Link>
        </Button>
        <Button
          variant={"link"}
          className="text-muted-foreground font-medium text-xs"
        >
          <Link href="/terms">Terms</Link>
        </Button>
      </div>
    </div>
  );
}
